var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew214({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 1.01,
    y: 1.01,
    width: 13.99,
    height: 13.99
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.53,4H6.88v.88H3.57V7.51H6.63v.87H3.57V12h-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.37,4.06a9.84,9.84,0,0,1,1.91-.17,3.33,3.33,0,0,1,2.22.59,1.69,1.69,0,0,1,.67,1.43A1.9,1.9,0,0,1,11.8,7.68v0a2.07,2.07,0,0,1,1.67,2,2.19,2.19,0,0,1-.68,1.62,4.06,4.06,0,0,1-2.8.76A11.75,11.75,0,0,1,8.37,12ZM9.42,7.37h.94c1.11,0,1.76-.58,1.76-1.35,0-.95-.72-1.32-1.78-1.32a4.14,4.14,0,0,0-.92.07Zm0,3.87a5,5,0,0,0,.87,0c1.08,0,2.08-.39,2.08-1.57s-.95-1.56-2.09-1.56H9.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew214);
export default __webpack_public_path__ + "static/media/Symbolpack_New_214.f7e6eb860f4af992eb42ac7167108861.svg";
export { ForwardRef as ReactComponent };